import React, { useContext as useContextCore } from 'react'

export type TaskActionsProviderProps = {
  taskId: string
  projectId: string
  canEdit: boolean
  children: React.ReactNode
}

export type DeleteActionContext = Omit<TaskActionsProviderProps, 'children'>

const context = React.createContext<DeleteActionContext>({} as DeleteActionContext)
const CoreProvider = context.Provider

export const TaskActionsProvider = ({ children, ...props }: TaskActionsProviderProps) => {
  return <CoreProvider value={{ ...props }}>{children}</CoreProvider>
}

export const useTaskActionsContext = () => useContextCore(context)
